<script setup lang="ts">
import { computed, ref } from 'vue'
import { micromark } from 'micromark'
import ItemIcon from './ItemIcon.vue'
import GenericExpansionIcon from './GenericExpansionIcon.vue'
import { ExoticWeapon } from '../enums/releases'
import collectibleDefinitions from '../generated/collectibleDefinitions.json'

var props = defineProps<{ exotic: ExoticWeapon, open: boolean }>()
const emit = defineEmits(['toggle'])

const collapsible = ref<HTMLInputElement | null>(null)
const collectible = computed(() => collectibleDefinitions.find(x => x.id === props.exotic.collectible))

function toggle() {
  emit('toggle')
}
</script>

<template>
  <div
    class="flex flex-col w-full font-semibold shadow-lg shadow-black/50 rounded-2xl relative overflow-hidden bg-white"
  >
    <div
      class="flex items-center gap-2 px-2 py-3 border-black/25 transition-all ease-in-out duration-300 cursor-pointer border-b-2 -mb-1"
      @click="toggle"
    >
      <GenericExpansionIcon :expansion="exotic.releasedWith" :other-classes="'h-8 w-8 mx-2' + (exotic.guide ? ' relative -top-2' : '')" />
      <ItemIcon :item="collectible" large class="relative" />
      <small v-if="exotic.guide" class="absolute top-[3.25rem] left-2 w-12 text-center text-xs">GUIDE</small>
      <div>
        <h2 class="text-xl leading-5">{{ collectible?.name }}</h2>
        <small class="text-xs block mt-1 -mb-0.5">{{ collectible?.type?.toUpperCase() }}</small>
        <span class="text-xs">Released {{ exotic.date?.toLocaleDateString('en-US', { dateStyle: 'long' }) }}</span>
        <img src="../assets/caret.svg" class="absolute top-4 right-4 h-4 w-4 transition-transform duration-350 opacity-75" alt="" :class="{ '-rotate-180': open }" />
      </div>
    </div>
    <div
      class="markdown text-sm transition-all ease-in-out duration-300"
      ref="collapsible"
      :style="{ 'max-height': open ? '999px' : '0px' }"
    >
      <div class="px-2 py-3">
        <p>{{ exotic.description }}</p>
        <span v-if="(typeof exotic.guide === 'string')" v-html="micromark(exotic.guide)" />
      </div>
    </div>
  </div>
</template>